/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import mpegts from 'mpegts.js';
import { BeijingMotor } from '@request'
import { tools } from 'newcar-ui/output/cjs/utils';
import { appMethods } from "newcar-ui/output/es/appMethods";
// import { Toast } from 'antd-mobile-v5'
import Loading from '../loading';
import { debounce } from 'lodash-es';

const StatusBlock = (props) => {
  const { content, status } = props
  return (
    <div className='error-block'>
      {status == 'error' && <img src='//icon.xgo-img.com.cn/mtouch/24041416/loaderror.png'></img>}
      <div className="error-block-msg">{content}</div>
    </div>
  )
}

function LivePlayer(props) {
  const { liveId, liveStatus, className, poster, title, liveSource = [] } = props;

  const curVideo = useRef(null);
  const player = useRef(null);
  const [loading, setLoading] = useState(false);
  const [muted, setMuted] = useState(true); // 声音开关
  const [liveError, setLiveError] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [showPlay, setShowPlay] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false)
  const [source, setSource] = useState(liveSource)
  const [wubLiveUrl, setWubLiveUrl] = useState('')
  const [useBehavior, setUserBehavior] = useState(false)

  // 当前 flv 流帧画面
  const currFrameRef = useRef(0)
  // 用于记录画面卡帧判断
  const frameStopCount = useRef(0)

  const timer = useRef(null);
  const waitingTimer = useRef(null);
  const playerTypeRef = useRef('');
  const retryCount = useRef(0);

  function onWaiting(e) {
    console.log('waitin data', e, player, curVideo)
    // if (playerTypeRef.current === 'm3u8') {
    //   const streamTime = e.timeStamp / 1000
    //   // curVideo.current.currentTime = streamTime
    //   console.log('m3u8', player.current?.currentTime, e.timeStamp, streamTime, player.current?.ended, player.current.duration)
    //   // console.log('m3u8', player.current.error, player.current.seekable?.start(), player.current.seekable?.end(),)
    // }
    if (playerTypeRef.current == 'flv') {
      return
    }
    // clearTimeout(timer.current);
    // clearTimeout(waitingTimer.current)
    // setTimeout(() => {
    //   !loading && setWaiting(true);
    //   waitingTimer.current = setTimeout(() => {
    //     setWaiting(false)
    //     console.log('endwaiting')
    //   }, 3000)
    // }, 1000);
  }
  // 绑定跳转 58APP
  function bindWbJumpe(url) {
    setTimeout(() => {
      window.callWbApp && window.callWbApp('.playarea', 'protocol', {
        jump: url   // 跳转协议,必填。 调起的pid，也需要在跳转协议中填写，用来统计调起来源     
      }, true);
    }, 500)
  }

  function getLiveInfo() {
    // setWaiting(true)
    BeijingMotor.getLiveRoomData({ liveId: liveId }).then((res) => {
      const { status, result: { playUrls, wbmainUrl, status: roomStatus } } = res;
      setWaiting(false)
      setLiveError(false)
      if (status != 0) {
        // 提示接口错误
        setLiveError(true)
        return
      }
      if (roomStatus === 0) {
        setIsEnd(true);
        setShowPlay(false)
        setIsPlaying(false)
        return
      }
      // const { playUrls, wbmainUrl } = result
      setWubLiveUrl(wbmainUrl)
      // if (!useBehavior) {
      //   bindWbJumpe(wbmainUrl)
      // }
      const resource = [{
        type: 'flv', src: playUrls[0].flvDownstreamAddress
      }, {
        type: 'hls', src: playUrls[0].hlsDownstreamAddress
      }]
      setSource(resource)
      if (!useBehavior) {
        if (mpegts.getFeatureList().mseLivePlayback) {
          createFlvPlayer();
        } else {
          createM3u8Player();
        }
      }
    })
  }

  useEffect(() => {
    if (liveStatus === 1) {
      setShowPlay(true)
      getLiveInfo()
      console.log('livesssss', wubLiveUrl)
    }
  }, [liveStatus])

  // 重置直播流
  function resetPlayerStream() {
    if (playerTypeRef.current === 'flv') {
      player.current.unload()
    } else if (playerTypeRef.current === 'm3u8') {
      // curVideo.current.src = ''
    }
  }

  function playVideo() {
    // 加载提示 获取当前直播间信息
    // 播放当前直播流
    // 如果播放器流已存在继续播放
    if (player.current && playerTypeRef.current == 'm3u8') {
      player.current.load();
      player.current.play();
      setLoading(false)
    } else {
      // 调取接口获取当前直播间最新状态
      getLiveInfo()
    }
  }

  function toggleMuted(e) {
    e.stopPropagation();
    setMuted((isMuted) => !isMuted);
    player.current.muted = !muted;
  }

  function onload() {
    // console.log('加载中')
    // TODO 增加 loading 动效
    setShowPlay(false)
    setLoading(false);
  }
  function onError(e) {
    // console.log('onerror', retryCount.current)
    if (retryCount.current == 0) {
      // 重试一次
      setWaiting(true)
      setTimeout(() => {
        getLiveInfo()
      }, 1500)

      retryCount.current++
    } else {
      // console.log('?????', e, playerTypeRef)
      setLoading(false);
      setShowPlay(true)
      setLiveError(true);
      setIsPlaying(false)
      resetPlayerStream()
    }

  }

  function onEnd() {
    if (player.current.paused) {
      return
    }
    // 再次刷新一遍直播间的状态
    getLiveInfo()
    console.log('onEnd')
    // Toast.show({
    //   content: '直播已结束'
    // })
  }

  function onPause() {
    setShowPlay(true)
    setMuted(true)
    if (playerTypeRef.current == 'm3u8') {
      // player.current.muted()
      curVideo.current.muted = true;
    }
    setIsPlaying(false)
    resetPlayerStream()
  }

  function onDestroyPlayer() {
    player.current.src = '';
    player.current.removeEventListener('loadeddata', onload, false);
    player.current.removeEventListener('error', onError, false);
    player.current.removeEventListener('pause', onPause, false);
    player.current.removeEventListener('end', onEnd, false)
  }

  function createM3u8Player() {
    const src = source.find(
      (i) => i.type === 'hls' || /\.m3u8$/.test(i.src),
    )?.src;
    if (!src) {
      return;
    }
    // const src = 'http://wliveplay.58cdn.com.cn/58zhaopin/ZPQ01780627468554657793.m3u8'
    playerTypeRef.current = 'm3u8'
    player.current = curVideo.current;
    player.current.on = function (type, callback) {
      player.current.addEventListener(type, callback, false);
    };
    curVideo.current.src = src;
    // 浏览器禁止播放器主动开放声音，需要有行为交互
    curVideo.current.muted = true;
    // curVideo.current.play();
    setMuted(true)
    player.current.addEventListener('loadeddata', onload, false);
    player.current.addEventListener('progress', debounce(playVideo, 10000), false)
    player.current.addEventListener('end', onEnd, false);
    // player.current.addEventListener('stalled', onStalled, false)
    player.current.addEventListener('error', onError, false);
    player.current.addEventListener('pause', onPause, false)
    player.current.destroy = onDestroyPlayer;
    if (typeof props.onLivePlayerReady !== 'undefined') {
      props.onLivePlayerReady(player)
    }
  }

  function createFlvPlayer() {
    const src = source.find(
      (i) => i.type === 'flv' || /\.flv$/.test(i.src),
    )?.src;
    if (!src) {
      return;
    }

    player.current = mpegts.createPlayer({
      isLive: true,
      type: 'flv',
      url: src,
    }, {
      isLive: true,
      liveBufferLatencyChasing: true,
      liveSync: true,
      // liveBufferLatencyMaxLatency: 0.9, // 最大缓存时间
      // liveBufferLatencyMinRemain: 0.2, // 最小缓存时间
      liveBufferLatencyChasingOnPaused: true
    });

    player.current.attachMediaElement(curVideo.current);
    player.current.muted = true;
    setMuted(true)
    if (useBehavior) {
      player.current.load();
      player.current.play();
    }
    // player.current.on('error', (e) => {
    //   setLoading(true);
    //   player.current.destroy && player.current.destroy();
    //   createM3u8Player();
    // });
    player.current.on('error', onError)

    player.current.on('scriptdata_arrived', onload);
    player.current.on('loading_complete', onEnd);
    player.current.on('pause', onPause)
    player.current.on(mpegts.Events.STATISTICS_INFO, function (e) {
      const { decodedFrames, droppedFrames } = e
      // console.log('STATISTICS_INFO', decodedFrames, droppedFrames, currFrameRef.current, frameStopCount.current)
      if (decodedFrames === currFrameRef.current) {
        frameStopCount.current++
      } else {
        frameStopCount.current = 0
      }
      // 画面卡帧了 刷新流
      if (frameStopCount > 10) {
        setWaiting(true)
        setTimeout(() => {
          resetPlayerStream()
          playVideo()
        }, 1500)
      }
      currFrameRef.current = decodedFrames
    })
    if (typeof props.onLivePlayerReady !== 'undefined') {
      props.onLivePlayerReady(player)
    }
  }


  useEffect(() => {
    if (source.length === 0 || curVideo.current === null) {
      return;
    }

    if (mpegts.getFeatureList().mseLivePlayback) {
      createFlvPlayer();
      playerTypeRef.current = 'flv'
    } else {
      createM3u8Player();
      playerTypeRef.current = 'm3u8'
    }

    return () => {
      player.current.unload && player.current.unload()
      player.current.destroy && player.current.destroy();
      // curVideo.current = null;
      clearTimeout(timer.current);
    };
  }, [source]);


  function onVisibilityChange(e) {
    if (document.visibilityState === 'hidden') {
      player?.current?.pause()
    }
  }

  useEffect(() => {
    // console.log('????isplaying', props.mutipleVideo, isPlaying)
    if (props.mutipleVideo && isPlaying) {
      player?.current.pause()
    }
  }, [props.mutipleVideo])

  useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])


  function onPlayClick(e) {
    // 阻止冒泡
    e.stopPropagation && e.stopPropagation()
    setLoading(true)
    setShowPlay(false)
    setWaiting(true)
    setUserBehavior(true)
    setLiveError(false)
    retryCount.current = 0
    tools.sendClickStatistics_wmda(342, {
      name: title,
      actionType: '24biae-live-click'
    })
    playVideo()
    if (typeof props.onPlayClick !== 'undefined') {
      props.onPlayClick()
    }
  }

  function onRoomClick() {
    if (isEnd || liveStatus === 0 || showPlay) {
      // Toast.show({
      //   content: '直播未开始'
      // })
      console.log('直播未开始')
      return
    }
    if (tools.is58App()) {
      appMethods.goto(wubLiveUrl)
    }
  }

  function onPlaying(e) {
    // clearTimeout(timer.current);
    // clearTimeout(waitingTimer.current);
    console.log('playing', e)
    setWaiting(false);
    setIsPlaying(true)
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',

      }}
      className={className}
      onClick={onRoomClick}
    >
      {liveStatus === 0 ? (
        <img
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          src={poster}
        ></img>
      ) : (
        <video
          style={{
            width: '100%',
            display: 'block',
            height: '100%',
            objectFit: 'cover',
            transition: 'all .5s ease-in-out',
          }}
          onWaiting={onWaiting}
          onPlaying={onPlaying}
          onCanPlay={onPlaying}
          onPause={onPause}
          disablepictureinpicture={'false'}
          loop={false}
          controls={false}
          playsInline
          id={liveId}
          ref={curVideo}
          poster={poster}
        ></video>
      )}
      <div className="videoCover" >
        {isEnd && <StatusBlock content="直播已结束" status='end'></StatusBlock>}
        {liveError && <StatusBlock content="直播间加载失败" status='error'></StatusBlock>}
        {waiting && <Loading tip={'资源加载中...'}></Loading>}
        {showPlay && <div className='liveButton' onClick={onPlayClick}></div>}
        {player && player.current && !isEnd && <div
          className={`volume ${!muted ? '' : 'muted'}`}
          onClick={toggleMuted}
        ></div>}
        {/* <div className='playarea' style={{
          width: '100%',
          display: showPlay ? 'none' : 'block',
          height: '100%'
        }} ></div> */}
      </div>
    </div>
  );
}

export default LivePlayer;
